export default "__VITE_ASSET__Dy$PVARf__"